export default __webpack_public_path__ + "static/media/a037-address-02.4ba2450b.png";